<script lang="ts">
	import type { PageProps } from "./$types";
	import { PrivacyPolicy } from "#lib/web-ui/blocks/index.js";

	let { data }: PageProps = $props();
	const { contact } = data.siteConfig;
</script>

<svelte:head>
	<title>Privacy Policy | Fergmar Home Buyers</title>
	<meta
		name="description"
		content="Review our privacy policy to understand how Fergmar Home Buyers protects your personal information and data."
	/>
	<meta name="viewport" content="width=device-width, initial-scale=1.0" />
	<meta property="og:title" content="Privacy Policy | Fergmar Home Buyers" />
	<meta property="og:site_name" content="Fergmar Home Buyers" />
	<meta
		property="og:description"
		content="Review our privacy policy to understand how Fergmar Home Buyers protects your personal information and data."
	/>
</svelte:head>

<PrivacyPolicy
	entityName="Fergmar Enterprises, LLC"
	domain="fergmarhomebuyers.com"
	email={contact.email}
	contactUrl="/contact"
	address={{
		street: contact.streetAddress,
		city: contact.city,
		state: contact.state,
		zip: contact.zipCode
	}}
	lastUpdated="November 14th, 2024"
/>
